import { render, staticRenderFns } from "./quality_list.vue?vue&type=template&id=23079c76&scoped=true"
import script from "./quality_list.vue?vue&type=script&lang=js"
export * from "./quality_list.vue?vue&type=script&lang=js"
import style0 from "./quality_list.vue?vue&type=style&index=0&id=23079c76&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23079c76",
  null
  
)

export default component.exports